import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";

const styles = StyleSheet.create({
    headerContainer: {
         padding:10,
        borderBottomColor: '#C8C8C8',
        borderBottomWidth: 1,
    },
    billTo: {
        color: '#000',
        fontSize: 8,
        marginTop:5
    },
    offerName:{
      color: '#000',
      fontSize: 10,
      backgroundColor:'#bfe4e0',
      padding:5,
    }
  });


  let CancellationModal = (data, index) => {
    return (
    <Text>
    <Text>
      {index == 0 ? "Before" : "After"}{" "}
      &#x202A;
      {index == 0
        ? moment(
          data.attributes.DateTo
        ).format("Do MMM YYYY")
        : moment(
          data.attributes.DateFrom
        ).format("Do MMM YYYY")}
      &#x202C;
    </Text>
    <Text>
      {`- ${data.attributes.PercentPrice}% of booking amount will be charged`}
    </Text>
  </Text>
    )
  };


  const CancellationAccommodationEjunifer = ({invoice}) => {

    //var startDate = invoice.startDate;
    
  //  const rowsCancel = invoice?.junifer?.CancellationPolicy && (invoice?.junifer?.CancellationPolicy?.PolicyRules?.Rule.map(
  //   (data, index) => {

  //  return <Text style={styles.billTo}>{CancellationModal(data, index)} <br/></Text>
  //   }
  //  ))

  //  const  constData =  <Text>Free Cancellation(100% refund) if you
  //  cancel this booking before  
  //  {invoice?.junifer?.CancellationPolicy && (invoice?.junifer?.CancellationPolicy.PolicyRules.Rule.length > 0 && moment(
  //   invoice?.junifer?.CancellationPolicy.PolicyRules.Rule[0].attributes.DateTo
  //  ).format("Do MMM YYYY"))} <br/>
  //  </Text>
  //const Chargeapplicable =<Text> The cancellation charges will be applicable as follows <b></b></Text>
   return (<View style={styles.headerContainer}>{invoice?.junifer?.ActualOfferName !='' &&(<Text style={styles.offerName}>{invoice?.junifer?.ActualOfferName}</Text>)}{invoice?.firstcancellationdate !="" &&(<Text style={styles.billTo}><b>Cancellation Policy: </b>Free Cancellation before {moment(
    invoice?.firstcancellationdate
  ).format("D MMM Y")}</Text>)}</View>)
  }

  export default CancellationAccommodationEjunifer